import { g } from '@hcie/core';

/**
 * Utility to apply the active selection mask to a target context.
 * Uses 'destination-in' composite operation to clip the context content.
 */
export function applySelectionMaskToCtx(targetCtx: CanvasRenderingContext2D) {
    if (!g.isSelectionActive || !g.selectionCanvas) return;

    targetCtx.save();
    targetCtx.globalCompositeOperation = 'destination-in';
    
    // Draw the selection mask (black and white or alpha) onto the context
    // because it's 'destination-in', only areas where the mask is opaque will remain
    targetCtx.drawImage(g.selectionCanvas as HTMLCanvasElement, 0, 0);
    
    targetCtx.restore();
}
